import { useRef, useState } from 'react';

// Runs `action` unless a previous run is still pending, and reports whether it can run now; the ref also covers a second click before the re-render
export const useSingleFlight = <A extends unknown[]>(action: (...args: A) => Promise<void>, enabled: boolean) => {
  const running = useRef(false);
  const [inFlight, setInFlight] = useState(false);

  const run = async (...args: A) => {
    if (running.current) return;
    running.current = true;
    setInFlight(true);
    try {
      await action(...args);
    } finally {
      running.current = false;
      setInFlight(false);
    }
  };
  return [run, enabled && !inFlight] as const;
};
